import { TabConfig } from '@common/components/Tab/tabs.types'
import { QCTaskPermission } from '@auth/permissionsEnum'
import QcTaskListTableMyTasks from '@qc_task_list_view/pages/QcTaskListTableMyTasks'
import QcTaskListTableTaskPool from '@qc_task_list_view/pages/QcTaskListTableTaskPool'
import QcTaskListTableCompletedTasks from '@qc_task_list_view/pages/QcTaskListTableCompletedTasks'
import QcTaskListTableTaskManager from '@qc_task_list_view/pages/QcTaskListTableTaskManager'

export enum QCTasksTabsKeyEnum {
  MY_TASKS = 'MY_TASKS',
  TASK_POOL = 'TASK_POOL',
  COMPLETE_TASKS = 'COMPLETE_TASKS',
  TASK_MANAGER = 'TASK_MANAGER',
}

export type QCTasksTabsKey = QCTasksTabsKeyEnum

export const createQCTasksTabs = (subjectId?: string): Record<QCTasksTabsKey, TabConfig> => ({
  MY_TASKS: {
    label: 'My tasks',
    content: <QcTaskListTableMyTasks subjectId={subjectId} />,
    permission: QCTaskPermission.VIEW_ASSIGNED_TASKS,
  },
  TASK_POOL: {
    label: 'Task pool',
    content: <QcTaskListTableTaskPool subjectId={subjectId} />,
    permission: QCTaskPermission.VIEW_TASK_POOL,
  },
  COMPLETE_TASKS: {
    label: 'Complete',
    content: <QcTaskListTableCompletedTasks subjectId={subjectId} />,
    permission: QCTaskPermission.VIEW_COMPLETED_TASKS,
  },
  TASK_MANAGER: {
    label: 'Task manager',
    content: <QcTaskListTableTaskManager subjectId={subjectId} />,
    permission: QCTaskPermission.MANAGE_TASKS,
  },
})
